/* ================================
   Clearance toggle (Trek & Travel)
================================ */
(function () {

  function getClearanceData() {
    var el = document.querySelector('[data-clearance-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function updateClearanceBanner(variantId) {
    var data = getClearanceData();
    if (!data) return;

    var isProductClearance = Array.isArray(data.productTags) &&
      data.productTags.some(function(t) { return t.toLowerCase() === 'clearance'; });
    var isVariantClearance = !!(data.clearanceVariants && data.clearanceVariants[String(variantId)]);
    var show = isProductClearance || isVariantClearance;

    document.querySelectorAll('[data-clearance-note]').forEach(function (el) {
      el.style.display = show ? '' : 'none';
    });
  }

  // Initial render on page load
  document.addEventListener('DOMContentLoaded', function () {
    var data = getClearanceData();
    if (!data) return;
    updateClearanceBanner(data.selectedVariantId);
  });

  // Fires whenever the user selects a different variant
  document.addEventListener('variantUpdate', function () {
    var input = document.querySelector('[data-variant-id-input]');
    if (input) {
      updateClearanceBanner(input.value);
    }
  });

})();